import { setCookie } from "../utils/cookies.js";
import { PageHooks } from "barba";

const localeCookieDuration = 365 * 24 * 60 * 60; // 1 an
const localeCookieName = "localecookie";

class BarbaLocaleCookie extends PageHooks {
    afterEnter() {
        // Set document language in cookie
        const lang = document.documentElement.lang;
        setCookie(localeCookieName, lang, {
            expireSeconds: localeCookieDuration,
            sameSite: "Strict"
        });
    }
}

new BarbaLocaleCookie();
